module.exports = __webpack_public_path__ + "static/media/dashboard.09652a4b.svg";